import {
  getLaunchDarklyRegion,
  useGoogleAnalyticsSetup,
  usePendoSetup,
} from "@certn/utils";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect, useMemo } from "react";

import constants from "../../constants";
import { useClientPortalBootstrap } from "./clientPortalBootstrapContext";
import { UserDetails } from "../types";
import { pendoMetadata } from "../utils";

export function BootstrapAuthorizedInstrumentation() {
  const { status, userDetails } = useClientPortalBootstrap();
  const userMetadata = useMemo(
    () => pendoMetadata(userDetails as UserDetails | undefined),
    [userDetails]
  );
  const ldClient = useLDClient();

  useGoogleAnalyticsSetup({
    userId: userDetails?.auth0_id,
    measurementIds: constants.VITE_GA_MEASUREMENT_IDS?.split(" ") || [],
  });
  usePendoSetup(userMetadata);

  useEffect(() => {
    if (status !== "authorized" || !userDetails?.auth0_id) {
      return;
    }

    const region = getLaunchDarklyRegion();

    if (userDetails.client_account?.auth0_id) {
      ldClient?.identify({
        kind: "multi",
        user: {
          kind: "user",
          key: userDetails.auth0_id,
          name: userDetails.auth0_email,
          is_client: true,
          region,
        },
        organization: {
          kind: "organization",
          key: userDetails.client_account.auth0_id,
          name: userDetails.client_account.auth0_display_name,
          is_client: true,
          region,
        },
      });
    } else {
      ldClient?.identify({
        kind: "user",
        key: userDetails.auth0_id,
        name: userDetails.auth0_email || "",
        is_client: true,
        region,
      });
    }
  }, [ldClient, status, userDetails]);

  return null;
}
